import { Link } from "react-router-dom";

const stats = [
  { value: "20+", label: "影视作品", icon: "ri-film-line" },
  { value: "10+", label: "资讯专题", icon: "ri-newspaper-line" },
  { value: "每日", label: "内容更新", icon: "ri-refresh-line" },
  { value: "2 大", label: "内容频道", icon: "ri-layout-grid-line" },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-primary-950 px-4 py-14 text-background-100 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
        <div>
          <p className="text-xs font-semibold tracking-[0.22em] text-accent-400">ABOUT THE SITE</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            明明不喜欢，是一个认真做内容的地方
          </h2>
          <p className="mt-5 text-sm leading-relaxed text-background-300 md:text-base">
            我们是一群对影视内容挑剔的编辑。明明不喜欢那些敷衍的介绍，也不想让好作品被埋没。
            于是有了这个平台——用清晰的剧情梳理、扎实的作品信息，帮你在纷繁的片单里，快速找到真正想看的那一部。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-background-300">
            这里覆盖电影与电视剧两大内容线，从最新资讯到剧情深度介绍，从分类筛选到个性化推荐，
            只为让每一次查找都变得简单、愉快。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-search-line" />
              搜索作品
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 self-center">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-primary-800 bg-primary-900/40 p-5"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500/15 text-accent-400">
                <i className={`${stat.icon} text-lg`} />
              </span>
              <p className="mt-4 font-heading text-2xl font-bold text-background-50">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}